import { render, staticRenderFns } from "./VolumeHigh.vue?vue&type=template&id=94f87cd8"
import script from "./VolumeHigh.vue?vue&type=script&lang=js"
export * from "./VolumeHigh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports